import { formatDecimal } from "./decimal";
import { formatFloat } from "./float";
import { formatValuta } from "./valuta";

export type MaskOptions =
  | "valuta"
  | "valuta_specific"
  | "valuta_per_sqm"
  | "surface"
  | "surface_specific"
  | "meters"
  | "decimal"
  | "float"
  | "percentage_comma"
  | "percentage"
  | "points"
  | null;

export function applyMask(value: any, mask?: MaskOptions) {
  switch (mask) {
    case "valuta":
      return formatValuta(value, 0);
    case "valuta_specific":
      return formatValuta(value, 2);
    case "valuta_per_sqm":
      return formatValuta(value, 2) + " / m²";
    case "percentage_comma":
      return (Number(value) * 100).toFixed(2) + " %";
    case "percentage":
      return formatFloat(value) + " %";
    case "points":
      return formatFloat(value) + " punten";
    case "surface":
      return value + " m²";
    case "surface_specific":
      return formatFloat(value) + " m²";
    case "meters":
      return value + " m'";
    case "decimal":
      return formatDecimal(value);
    case "float":
      return formatFloat(value);
    default:
      return value;
  }
}
